import type { LabelConfig, LegendConfig, StyleConfig } from './config';

export type WorkspaceModule = 'project' | 'selection' | 'data' | 'symbology' | 'labels' | 'presentation' | 'export';
export type PresentationPresetId = 'free-map' | 'varieties' | 'work-progress' | 'executive-map';

export interface KpiConfig {
  readonly id: string;
  readonly label: string;
  readonly metric: 'entities' | 'area-ha' | 'selected-entities' | 'selected-area-ha';
  readonly visible: boolean;
}

export interface PresentationWorkspaceConfig {
  readonly title: string;
  readonly subtitle: string;
  readonly date: string;
  readonly showTitle: boolean;
  readonly showLegend: boolean;
  readonly showKpis: boolean;
  readonly showLabels: boolean;
  readonly showScale: boolean;
  readonly showNorth: boolean;
  readonly showBasemap: boolean;
  readonly showFrame: boolean;
  readonly backgroundColor: string;
  readonly kpis: readonly KpiConfig[];
  readonly logoSlots: readonly string[];
}

export interface WorkspacePreset {
  readonly id: PresentationPresetId;
  readonly name: string;
  readonly description: string;
  readonly suggestedField: string | null;
  readonly labelConfig: Partial<LabelConfig>;
  readonly styleConfig: Partial<StyleConfig>;
  readonly legendConfig: Partial<LegendConfig>;
  readonly presentation: Partial<PresentationWorkspaceConfig>;
}

export const defaultPresentationWorkspaceConfig: PresentationWorkspaceConfig = {
  title: 'CASUR GeoStudio',
  subtitle: '',
  date: new Date().toISOString().slice(0, 10),
  showTitle: false,
  showLegend: true,
  showKpis: false,
  showLabels: true,
  showScale: true,
  showNorth: false,
  showBasemap: true,
  showFrame: false,
  backgroundColor: '#eef3f0',
  kpis: [
    { id: 'visible-entities', label: 'Entidades visibles', metric: 'entities', visible: true },
    { id: 'visible-area', label: 'Área visible', metric: 'area-ha', visible: true },
    { id: 'selected-entities', label: 'Entidades seleccionadas', metric: 'selected-entities', visible: false },
    { id: 'selected-area', label: 'Área seleccionada', metric: 'selected-area-ha', visible: false },
  ],
  logoSlots: [],
};

export const workspacePresets: readonly WorkspacePreset[] = [
  { id: 'free-map', name: 'Mapa libre', description: 'Mapa técnico sin composición adicional.', suggestedField: null, labelConfig: {}, styleConfig: {}, legendConfig: { visible: false }, presentation: { showTitle: false, showLegend: false, showKpis: false, showNorth: false, showFrame: false } },
  { id: 'varieties', name: 'Variedades', description: 'Punto de partida categorizado; el campo se confirma en el motor temático.', suggestedField: 'Variedad', labelConfig: { target: 'suerte' }, styleConfig: {}, legendConfig: { visible: true, showCount: true, showArea: true }, presentation: { showLegend: true, showLabels: true } },
  { id: 'work-progress', name: 'Avance de labores', description: 'Plantilla genérica para cualquier actividad, campo y estados definidos por el usuario.', suggestedField: null, labelConfig: { target: 'suerte' }, styleConfig: {}, legendConfig: { visible: true, showCount: true, showArea: true }, presentation: { showLegend: true, showKpis: true, showLabels: true } },
  { id: 'executive-map', name: 'Mapa ejecutivo', description: 'Composición limpia con encabezado, indicadores, leyenda, escala y norte.', suggestedField: null, labelConfig: {}, styleConfig: {}, legendConfig: { visible: true, showCount: true, showArea: true }, presentation: { showTitle: true, showLegend: true, showKpis: true, showNorth: true, showScale: true, showFrame: true } },
];
